import { io } from 'socket.io-client';
import { useAuthStore } from '@/stores/auth.store';
import { normalizeToken } from '@/services/auth-token';

let socket;
let heartbeat;

function stopHeartbeat() {
  if (heartbeat) window.clearInterval(heartbeat);
  heartbeat = undefined;
}

function startHeartbeat(instance) {
  stopHeartbeat();
  heartbeat = window.setInterval(() => {
    if (instance.connected) instance.emit('presence:heartbeat', () => undefined);
  }, 30_000);
}

function authenticationCode(error) {
  return String(error?.data?.code || error?.code || error?.message || '');
}

export function getAdminSocket() {
  const token = normalizeToken(useAuthStore.getState().accessToken);
  if (!token) throw new Error('Admin session is unavailable.');

  if (!socket || socket.auth?.token !== token) {
    closeAdminSocket();
    socket = io(import.meta.env.VITE_SOCKET_URL || window.location.origin, {
      path: '/socket.io',
      transports: ['websocket'],
      auth: { token, role: 'admin' },
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
    });
    socket.on('connect', () => startHeartbeat(socket));
    socket.on('disconnect', stopHeartbeat);
    socket.on('connect_error', (error) => {
      const code = authenticationCode(error);
      if (code.includes('TOKEN_EXPIRED') || code.includes('TOKEN_INVALID') || code.includes('SESSION_REVOKED')) {
        useAuthStore.getState().clear();
        closeAdminSocket();
      }
    });
  } else if (socket.disconnected) {
    socket.connect();
  }
  return socket;
}

export function closeAdminSocket() {
  stopHeartbeat();
  socket?.disconnect();
  socket = undefined;
}
